import { Alert } from 'antd';
import React from 'react';
import { MdOutlineError } from 'react-icons/md';

interface AlertMessageProps {
  className?: string;
  message: string;
  showIcon?: boolean;
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  className = '',
  message,
  showIcon = false,
}) => (
  <Alert
    className={className}
    style={{
      width: '100%',
      backdropFilter: 'blur(20px)',
      backgroundColor: '#FFFFFFB2',
      boxShadow: '0 1px 4px 0 #0000000D',
      borderRadius: '10px',
      border: '1px solid var(--color-border-glass)',
    }}
    title={message}
    showIcon={showIcon}
    icon={<MdOutlineError size={16} color="var(--color-text-primary)" />}
  />
);

export default AlertMessage;
